<template>
    <div class="payment-info">
        <div class="point">
            <p>Никнейм</p>
            <p class="data">{{name}}</p>
        </div>
        <div class="point">
            <p>Привилегия</p>
            <p class="data">{{perk}}</p>
        </div>
        <div class="point">
            <p>Стоимость</p>
            <p class="data">{{cost}} ₽</p>
        </div>
        <div class="point">
            <p>Дата покупки</p>
            <p class="data">{{date | getDate}}</p>
        </div>
    </div>
</template>

<script>
    import moment from "moment";

    export default {
        name: "payment_info",
        props:{
            name: String,
            perk: String,
            cost: Number,
            date: Number,
        },

        filters: {
            getDate(time){
                return moment(time).calendar();
            }
        },
    }
</script>

<style scoped lang="scss">
    .payment-info{
        width: 100%;
        .point{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .data{
                color: white;
            }
            &:not(:last-child){
                margin-bottom: 12px;
            }
        }
    }
</style>